const accepted_cookies = 'accepted_cookies'

export const checkIdfaAndCookieTrackingEnabled = () => document.cookie.includes(accepted_cookies)

export const enableIdfaAndCookieTracking = () => {
  if (navigator.cookieEnabled) {
    document.cookie = `${accepted_cookies}=yes;`
    return
  }
  throw new Error('User Cookies Permission Denied. Enable Cookies in browser settings.')
}

export const checkLocationTrackingEnabled = async () => {
  if (!navigator.geolocation || !navigator.permissions) {
    return false
  }
  try {
    const permissionStatus = await navigator.permissions.query({ name: 'geolocation' })
    return permissionStatus.state === 'granted'
  } catch {
    return false
  }
}

export const enableLocationTracking = () =>
  new Promise<void>((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Location tracking is unavailable in this browser.'))
    }
    navigator.geolocation.getCurrentPosition(() => resolve(), reject)
  })
